<script setup lang="ts">
import type { IProps } from '~/components/entity/card'
import type { ICardSystems } from '~/components/widget/select-card-system'
import type { IResponseData } from '~/types'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/card_systems', { ...props.queryParams }))
const { data } = useApi<IResponseData<ICardSystems[]>>(() => url, {
  key: 'card-systems-sidebar-widget'
})
const cardSystems = computed(() => {
  return data.value?.data.map((i) => {
    return {
      title: i.title,
      url: `/cards/system/${i.slug}`,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="cardSystems"
    :heading-text="$t('widget.select_card_system.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="cardSystems" />
  </SidebarBlock>
</template>
